class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    
    // Check if this is a mega menu (has mega-menu class)
    if (this.mainDetailsToggle.classList.contains('mega-menu')) {
      this.setupMegaMenuHover();
    }
  }

  setupMegaMenuHover() {
    const summary = this.mainDetailsToggle.querySelector('summary');
    const content = this.mainDetailsToggle.querySelector('.mega-menu__content');
    
    // Check if device supports hover
    const supportsHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    
    if (supportsHover) {
      // Remove click behavior from summary for hover devices
      summary.addEventListener('click', (e) => {
        e.preventDefault();
      });

      // Add hover events with timeout for safety
      let hoverTimeout;
      
      this.mainDetailsToggle.addEventListener('mouseenter', () => {
        clearTimeout(hoverTimeout);
        this.openMegaMenu();
      });

      this.mainDetailsToggle.addEventListener('mouseleave', () => {
        hoverTimeout = setTimeout(() => {
          this.closeMegaMenu();
        }, 500); // Increased delay to 500ms
      });

      // Keep menu open when hovering over content
      if (content) {
        content.addEventListener('mouseenter', () => {
          clearTimeout(hoverTimeout);
          this.openMegaMenu();
        });

        content.addEventListener('mouseleave', () => {
          hoverTimeout = setTimeout(() => {
            this.closeMegaMenu();
          }, 500); // Increased delay to 500ms
        });
      }
    } else {
      // On touch devices, keep the original click behavior for accessibility
      summary.addEventListener('click', (e) => {
        // Allow default behavior for touch devices
      });
    }
  }

  openMegaMenu() {
    this.mainDetailsToggle.setAttribute('open', '');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', 'true');
    this.onToggle();
  }

  closeMegaMenu() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', 'false');
    this.onToggle();
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
